import { render, staticRenderFns } from "./vehicle-type.vue?vue&type=template&id=0e9c66ef&scoped=true"
import script from "./vehicle-type.vue?vue&type=script&lang=js"
export * from "./vehicle-type.vue?vue&type=script&lang=js"
import style0 from "./vehicle-type.vue?vue&type=style&index=0&id=0e9c66ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9c66ef",
  null
  
)

export default component.exports